<template>
    <container xs-tight md-full lg-full xl-full class="stretch-layout">
        <row v-if="sponsors.length" tight>
            <column v-for="sponsor in sponsors" :sponsor="sponsor" :key="sponsor.id" cols="6" sm="4" md="3">
                <sponsor-card v-if="sponsor.model_name === 'sponsor'" :sponsor="sponsor"/>
                <lazy-ad-card v-else-if="sponsor.model_name === 'ad'" :ad="sponsor"/>
            </column>
        </row>
        <missing-info v-else :text="$t('missing.sponsor.index')" card class="flex-grow-1"/>
    </container>
</template>

<script setup lang="ts">
import {EventPageType} from "@spoferan/spoferan-ts-core";
import {useEventStore} from "../../../store/event";
const eventStore = useEventStore();
const {t} = useI18n();
const {$api, $web} = useNuxtApp();
const route = useRoute();

// Make sure the page is activated
if (!eventStore.hasActivePage(EventPageType.Sponsors)) {
	await navigateTo($web('events.show', route.params.event));
}

const {data: sponsors} = await useApiFetch($api('events.sponsors.index', eventStore.event.id), {
	guest: true,
	params: {
		with_ads: true
	}
})

useMeta({
	title: eventStore.buildPageTitle(t('view.events.sponsors.index.title', {event: eventStore.event.display_name})),
	description: t('view.events.sponsors.index.description', {event: eventStore.event.display_name})
})
</script>

